export const GET_SELLER = 'get-seller';

export default function getSeller({ sellerId }) {
  return {
    type: GET_SELLER,
    payload: { sellerId },
  };
}
